import { CircularProgress, Typography } from "@material-ui/core";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getVocabularyContents } from "../../../redux/actions/vocabularyCenterAction";
import { useNavigate } from "react-router-dom";
import { getRandomNumber } from "../../shared/utils/sharedUtils";

const OverAllTopicList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { peopleInformation, common, vocabularyContents } = useSelector((state: any) => state);

  useEffect(() => {
    if (peopleInformation?.data && common?.lgId) {
      const { token, accountId } = peopleInformation.data.getpeopleInformation;
      dispatch(getVocabularyContents(common.lgId, token, parseInt(accountId, 10)));
    }
  }, [peopleInformation, common]);

  return (
    <div className="word-lists" data-testid="word-lists">
      <div className="vocabulary-center-topic-level-details">
        {vocabularyContents.topicsListData === null ? (
          <div className="loader-wrapper">
            <CircularProgress color="primary" className="circularLoader" size={100} />
          </div>
        ) : (
          vocabularyContents.topicsListData?.map(
            (
              topicLevelDetail: {
                topic: string;
                headerTitle:
                  | string
                  | number
                  | boolean
                  | React.ReactElement<any, string | React.JSXElementConstructor<any>>
                  | Iterable<React.ReactNode>
                  | React.ReactPortal
                  | null
                  | undefined;
                listLength:
                  | string
                  | number
                  | boolean
                  | React.ReactElement<any, string | React.JSXElementConstructor<any>>
                  | Iterable<React.ReactNode>
                  | React.ReactPortal
                  | null
                  | undefined;
              },
              index: number,
            ) => (
              <button
                className={`remove-button-default-style topic-level-card ${topicLevelDetail.headerTitle}`}
                data-testid={`topic-level-card${index}`}
                key={getRandomNumber(index)}
                onClick={() => {
                  navigate(`/vocabularycenter/${topicLevelDetail.topic}`);
                }}
              >
                <div className={`topic-level-card-content`} data-testid="topicLevelCardContent">
                  <Typography gutterBottom variant="h5" component="div" className={`topic-level-card-title`}>
                    {topicLevelDetail.headerTitle}
                  </Typography>
                  <Typography variant="body2" className={`topic-level-card-details`}>
                    {topicLevelDetail.listLength} Word lists
                  </Typography>
                </div>
              </button>
            ),
          )
        )}
      </div>
    </div>
  );
};

export default OverAllTopicList;
